import { stringArrayToObject } from '~utils/array';

export const TYPES_LIST = ['event', 'project'];
export const TOPICS_LIST = ['energy', 'transport', 'boundary', 'telecommunications'];

export const TYPES = stringArrayToObject(TYPES_LIST);
export const TOPICS = stringArrayToObject(TOPICS_LIST);
